import React, { useState, useEffect, useContext } from "react";
import { formatAmount } from "../../../utils/money";
import Modal from "react-bootstrap/Modal";
import Accountingtb from "./accountingtb";
import PocketExchange from "./newPocketExchange";
import DailyDrawerExchange from "./DailyDrawerExchange";
import Exchange from "./exchange";
import ResellerCollect from "./ResellerCollect";
import "./accounting.css";
import AuthContext from "../../context/AuthContext";
import LanguageContext from "../../context/LanguageContext";
import axios from "axios";
import { API_URL } from "../../components/api";
import { NavLink } from "react-router-dom";
import Payment from "./payment";
import OnlineDrawerBreakdown from "./OnlineDrawerBreakdown";

function Accounting({ collectorsOnly = false }) {
  const { user } = useContext(AuthContext);
  const { direction, t } = useContext(LanguageContext);

  const [balanceDrawerUSD, setBalanceDrawerUSD] = useState(0);
  const [balanceDrawerLBP, setBalanceDrawerLBP] = useState(0);
  const [drawerName, setDrawerName] = useState("");
  const [onlineDrawerMethods, setOnlineDrawerMethods] = useState(null);
  const summarizeOnlineAccounts = (accounts) => {
    const totals = {
      whish: {
        balance_usd: 0,
        balance_lbp: 0,
      },
      omt: {
        balance_usd: 0,
        balance_lbp: 0,
      },
    };

    (Array.isArray(accounts) ? accounts : []).forEach(
      (account) => {
        const method = String(
          account.payment_method || ""
        ).toLowerCase();

        if (!totals[method]) {
          return;
        }

        totals[method].balance_usd += Number(
          account.balance_usd || 0
        );

        totals[method].balance_lbp += Number(
          account.balance_lbp || 0
        );
      }
    );

    return {
      whish: {
        balance_usd:
          totals.whish.balance_usd.toFixed(2),
        balance_lbp:
          totals.whish.balance_lbp.toFixed(2),
      },
      omt: {
        balance_usd:
          totals.omt.balance_usd.toFixed(2),
        balance_lbp:
          totals.omt.balance_lbp.toFixed(2),
      },
    };
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [showPocket, setShowPocket] = useState(false);
  const handleClosePocket = () => setShowPocket(false);
  const handleShowPocket = () => setShowPocket(true);
  const [showResellerCollect, setShowResellerCollect] = useState(false);
  const handleCloseResellerCollect = () => setShowResellerCollect(false);
  const handleShowResellerCollect = () => setShowResellerCollect(true);

  const [showPayment, setShowPayment] = useState(false);
  const handleClosePayment = () => setShowPayment(false);
  const handleShowPayment = () => setShowPayment(true);

  // New state to handle which modal to show
  const [isDailyDrawerExchange, setIsDailyDrawerExchange] = useState(false);

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setIsDailyDrawerExchange(false); // Reset the toggle when modal is closed
  };

  const fetchData = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.get(
        `${API_URL}/inventory/pocket/exchange/new/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        }
      );

      if (response.status === 200) {
        const data = response.data;
        setBalanceDrawerUSD(data.smallest_drawer.balance_usd);
        setBalanceDrawerLBP(data.smallest_drawer.balance_lbp);
        setDrawerName(data.smallest_drawer.drawer_name);
        setErrorMessage(""); // Clear any previous error message
        console.log(data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    const fetchOnlineDrawer = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(
          `${API_URL}/accounting/online-drawer/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              page: 1,
              page_size: 1,
            },
          }
        );

        setOnlineDrawerMethods(
            summarizeOnlineAccounts(
              response.data.online_accounts
            )
          );
      } catch (error) {
        setOnlineDrawerMethods(null);
        console.error(error);
      }
    };

    fetchOnlineDrawer();
  }, [user.username]);

  useEffect(() => {
    fetchData();
  }, [user.username]);

    useEffect(() => {
      const refreshOnlineDrawer = async () => {
        try {
          const authTokens = JSON.parse(
            localStorage.getItem("authTokens")
          );

          const response = await axios.get(
            `${API_URL}/accounting/online-drawer/`,
            {
              headers: {
                Authorization:
                  `Bearer ${authTokens.access}`,
              },
              params: {
                page: 1,
                page_size: 1,
              },
            }
          );

          setOnlineDrawerMethods(
            summarizeOnlineAccounts(
              response.data.online_accounts
            )
          );
        } catch (error) {
          console.error(error);
        }
      };

      const handleOnlineDrawerUpdated = () => {
        refreshOnlineDrawer();
      };

      window.addEventListener(
        "oss-online-drawer-updated",
        handleOnlineDrawerUpdated
      );

      return () => {
        window.removeEventListener(
          "oss-online-drawer-updated",
          handleOnlineDrawerUpdated
        );
      };
    }, []);

  const handleToggle = () => {
    setIsDailyDrawerExchange(!isDailyDrawerExchange);
  };
  return (
    <div className="accounting" dir={direction}>
      <div className={`accounting-top${collectorsOnly ? " collectors-top" : ""}`}>
        <button onClick={handleShow} className="AddClient">
          {t("collection.drawerExchange")}
        </button>
        {!collectorsOnly && (
          <>
            <button onClick={handleShowPocket} className="AddClient">
              {t("collection.pocketExchange")}
            </button>
            <button onClick={handleShowResellerCollect} className="AddClient">
              {t("collection.resellerPayment")}
            </button>
            <button onClick={handleShowPayment} className="AddClient">
              {t("collection.payment")}
            </button>
            <NavLink
              exact
              to="/accounting/report/monthly"
              activeClassName="active"
              className="AddClient"
              style={{ textDecoration: "none" }}
            >
              {t("collection.monthlyReport")}
            </NavLink>{" "}
          </>
        )}
        <h4 className="drawer">{drawerName}</h4>
        <h4 className="drawer">{t("collection.balanceUsd")} {formatAmount(balanceDrawerUSD, 2)}</h4>
        <h4 className="drawer">{t("collection.balanceLbp")} {formatAmount(balanceDrawerLBP, 2)}</h4>
        {onlineDrawerMethods && (
          <div className="accounting-online-drawer">
            <OnlineDrawerBreakdown
              method="whish"
              balance={onlineDrawerMethods.whish}
            />
            <OnlineDrawerBreakdown
              method="omt"
              balance={onlineDrawerMethods.omt}
            />
          </div>
        )}
      </div>
      <div className="main_accounting">
        <Accountingtb fetchDrawer={fetchData} walletOnly={collectorsOnly} />
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        className={`modal-lg${collectorsOnly ? " collectors-drawer-exchange-modal" : ""}`}
      >
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>
              {isDailyDrawerExchange ? t("collection.dailyDrawerExchange") : t("collection.exchange")}
            </Modal.Title>
          </Modal.Header>

          {/* Toggle Switch Inside the Modal */}
          <div className="modal-toggle">
            <label>
              <input
                type="checkbox"
                checked={isDailyDrawerExchange}
                onChange={handleToggle}
              />
              {isDailyDrawerExchange ? ` ${t("collection.dailyDrawerExchange")}` : ` ${t("collection.exchange")}`}
            </label>
          </div>

          {/* Render the appropriate component based on the toggle */}
          {isDailyDrawerExchange ? <DailyDrawerExchange /> : <Exchange />}
        </div>
      </Modal>

      <Modal show={showPocket} onHide={handleClosePocket} className="modal-lg">
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{t("collection.pocketMoneyExchange")}</Modal.Title>
          </Modal.Header>
          <PocketExchange />
        </div>
      </Modal>

      <Modal
        show={showResellerCollect}
        onHide={handleCloseResellerCollect}
        className="modal-lg"
      >
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{t("collection.resellerCollect")}</Modal.Title>
          </Modal.Header>
          <ResellerCollect
            handleClose={handleCloseResellerCollect}
            closeDrawer={fetchData}
          />
        </div>
      </Modal>

      <Modal
        show={showPayment}
        onHide={handleClosePayment}
        className="modal-lg accounting-payment-modal"
      >
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{t("collection.payment")}</Modal.Title>
          </Modal.Header>
          <Payment />
        </div>
      </Modal>
    </div>
  );
}

export default Accounting;
